function startPaginationTimer(index: number): void {
  const bullets = document.querySelectorAll('.swiper-pagination-bullet');
  bullets.forEach((b, i) => {
    const progress = b.querySelector<HTMLElement>('.progress');
    if (progress) {
      progress.style.transitionDuration = '0s';
      progress.style.strokeDashoffset = '100';
      if (i === index) {
        setTimeout(() => {
          progress.style.transitionDuration = '15s';
          progress.style.strokeDashoffset = '0';
        }, 0);
      }
    }
  });
}

interface SwiperInstance {
  slidePrev?: (speed?: number) => void;
  slideNext?: (speed?: number) => void;
}

/**
 * Hero section Swiper with circle progress pagination + minimal prev/next nav
 */
export class HeroSlider {
  private swiper: SwiperInstance | null = null;

  init(): void {
    if (typeof window.Swiper === 'undefined') return;

    const el = document.querySelector('.no-main-hero__slider');
    if (!el) return;

    this.swiper = new (window as Window & { Swiper: new (el: Element, o: object) => SwiperInstance }).Swiper(
      el,
      {
        slidesPerView: 1,
        speed: 1600,
        loop: true,
        effect: 'slide',
        autoplay: { delay: 10000 },
        pagination: {
          el: '.no-main-hero__slider .swiper-pagination',
          clickable: true,
          renderBullet: (index: number, className: string) =>
            `<span class="${className}"><svg class="circle-timer" viewBox="0 0 26 26"><circle class="bg" cx="13" cy="13" r="12"/><circle class="progress" cx="13" cy="13" r="12"/></svg></span>`,
        },
        on: {
          init: function (this: { realIndex: number }) {
            startPaginationTimer(this.realIndex);
          },
          slideChangeTransitionStart: function (this: { realIndex: number }) {
            startPaginationTimer(this.realIndex);
          },
        },
      }
    );

    const inner = el.closest('.no-visual__inner');
    if (inner) {
      const prevBtn = inner.querySelector<HTMLButtonElement>('.no-visual__nav--prev');
      const nextBtn = inner.querySelector<HTMLButtonElement>('.no-visual__nav--next');
      if (prevBtn && this.swiper.slidePrev) {
        prevBtn.addEventListener('click', () => this.swiper?.slidePrev?.());
      }
      if (nextBtn && this.swiper.slideNext) {
        nextBtn.addEventListener('click', () => this.swiper?.slideNext?.());
      }
    }
  }
}
